/**
 * Where a purchase request's lead time came from.
 *
 * The purchasing planner offers three ways to answer "how long does this take to arrive", and the
 * request stores BOTH the answer (`leadTimeBusinessDays`) and which of the three produced it. The
 * source is not bookkeeping — it is what selects the open tab when the request panel is reopened,
 * so an agent returns to the reasoning they left rather than to a default.
 *
 * It also changes how much the number should be trusted, which nothing else on the request says.
 * Eleven business days derived from four closed orders and eleven typed in after a phone call are
 * the same number and not the same fact; only the source distinguishes them.
 */
export enum PurchaseRequestLeadTimeSource {
    /** Derived from this item's own closed purchase orders — the gap from orderedOn to receivedOn. */
    History = 'History',
    /** Copied from the vendor's `leadTimeBusinessDays` standard. */
    VendorStandard = 'VendorStandard',
    /** Typed in by a purchasing agent. Beats both of the others, because it is the only one that
     *  can know something that has not happened yet. */
    Manual = 'Manual',
}
